<template>
    <v-container style="height:100%;">
        <v-layout v-if="currentSen" column justify-space-between>
            <v-flex xs12>
                <v-card class="elevation-10 pa-1 ma-2">
                    <v-card-title class="pa-1">
                        <p class="text-xs-center ma-0 nom-sen">{{currentSen.qualite}}  {{currentSen.prenomUsuel}} {{currentSen.nomUsuel}}</p>
                    </v-card-title>
                    <v-card-media contain :src="`https://www.senat.fr/senimg/${currentSen.baseNotice}.jpg`" height="225px"></v-card-media>
                    <v-card-actions>
                        <v-container fluid fill-width>
                            <v-layout fill-width child-flex-sm row wrap>
                                <v-flex xs12>
                                    <v-btn large :href="`https://www.senat.fr/senateur/${currentSen.baseNotice}.html`" target="_blank">Notice</v-btn>
                                </v-flex>
                                <v-flex v-for="url in currentSen.urls" xs12 :key="url.type">
                                    <v-btn :href="url.url" target="_blank">{{getLibelleType(url.type).lic}}</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card class="elevation-5 pa-1 ma-2">
                    <v-card-title>Groupe politique&nbsp;:</v-card-title>
                    <v-card-media contain :src="`https://www.senat.fr/assets/images/partagees/groupes/${currentSen.codeGrppol}.webp`" height="55px" class="mt-2"></v-card-media>
                    <v-card-text class="pa-1"><p class="text-xs-center">{{currentSen.groupePolitiqueCourant}}</p></v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card class="elevation-5 pa-1 ma-2">
                    <v-card-title>Circonscription&nbsp;:</v-card-title>
                    <v-card-media contain :src="`https://www.senat.fr/assets/images/circo/circonscription_${currentSen.codeDpt}.svg`" height="151px" class="mt-2"></v-card-media>
                    <v-card-actions>
                        <v-btn small :href="`https://www.senat.fr/senateurs/sencir.html#c${currentSen.codeCirco}`" target="_blank">Sénateurs</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card class="elevation-2 pa-1 ma-2">
                    <v-card-title>Export&nbsp;:</v-card-title>
                    <v-card-actions>
                        <v-container fluid fill-width class="pa-0">
                            <v-layout fill-width child-flex-sm row wrap>
                                <v-flex xs6>
                                    <v-btn small :href="`https://www.senat.fr/calendrier_activite/csv/sen_${currentSen.matricule}.csv`" target="_blank">CSV</v-btn>
                                </v-flex>
                                <v-flex xs6>
                                    <v-btn small :href="`https://www.senat.fr/calendrier_activite/json/sen_${currentSen.matricule}.json`" target="_blank">JSON</v-btn>
                                </v-flex>
                                <v-flex xs6>
                                    <v-btn small :href="`https://www.senat.fr/calendrier_activite/xlsx/sen_${currentSen.matricule}.xlsx`" target="_blank">XLSX</v-btn>
                                </v-flex>
                                <v-flex xs6>
                                    <v-btn small :href="`https://www.senat.fr/calendrier_activite/ics/sen_${currentSen.matricule}.ics`" target="_blank">ICS</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {mixin} from "./Senateur.mixin";
import * as types from "../store/types";

export default {
  mixins: [mixin],
  methods: {
    getLibelleType(code) {
      return this.$store.getters[types.ACCEDE_TYPURL_PAR_CODE](code);
    }
  }
};
</script>

<style scoped>
    .card__title {
        padding-top: 0;
        padding-bottom: 0;
        font-weight: bold;
    },
    .nom-sen {
        width: 100%;
        font-size: large;
    }
</style>



// WEBPACK FOOTER //
// SenateurDroite.vue?441e8593